import { TCommonData, TWidget } from '@libs/types';
import { useThemeHook, type TCoreLayoutOptions } from '@core/widgets';

/**
 * Resolves a carousel theme palette for a given style key.
 * Synthesizes a theme-only widget (no data) so `useThemeHook` can resolve
 * `localKey` under an optional `parentKey`. Shared by the container
 * (`CarouselView`) and the per-item `CarouselSlide`, which each need their
 * own hook call.
 */
export const useCarouselPalette = (localKey: string, parentKey?: string): Record<string, unknown> => {
    const widget = {
        uid: '',
        data: {},
        options: { style: localKey, parentStyleNames: parentKey ? [parentKey] : [] },
    } as unknown as TWidget<TCommonData, TCoreLayoutOptions>;
    return useThemeHook(widget, '').palette as unknown as Record<string, unknown>;
};
